import { QuestionnaireQueryInterface } from '../api/interfaces';
import { questionnairesPageActionTypes } from '@actions/actionTypes/questionnairesPage';
import { setMgLocalStorage } from '@utils';
import { MgLocalStorageKeys } from '@enums';
import { makeAllQuestionnaires } from '@actions/questionnaireActions';

export const setFilters = (value: QuestionnaireQueryInterface) => {
  return {
    type: questionnairesPageActionTypes.SET_QUESTIONNAIRES_FILTERS,
    payload: { ...value },
  };
};

export const setPartialQuestionnairesFilters = (value: Partial<QuestionnaireQueryInterface>) => {
  return (dispatch, getState) => {
    const store = getState();
    const filters = store.questionnairesPage.filters;

    const updatedQuery = { ...filters, ...value };
    dispatch(setFilters(updatedQuery));
    setMgLocalStorage(MgLocalStorageKeys.QUESTIONNAIRE_FILTERS, updatedQuery);
    dispatch(makeAllQuestionnaires(updatedQuery));
  };
};
